import React from 'react'
import ReactDOM from 'react-dom/client'

import ToastProvider from './components/Toast';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App.jsx'

import './index.css'

const queryClient = new QueryClient();

if (window.__PRELOADED_DATA__) {
  const locationId = window.location.pathname.split('/report/')[1];
  
  for (const [queryKeyName, data] of Object.entries(window.__PRELOADED_DATA__)) {
    const queryKey = [queryKeyName, locationId];
    
    queryClient.setQueryData(queryKey, data);
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
